import React from "react";
import { Form, Input, Select, Button, Space, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined, SyncOutlined } from "@ant-design/icons";

const { Option } = Select;

const statusOptions = [
    { value: "AVAILABLE", label: "可用" },
    { value: "PARTIALLY_ALLOCATED", label: "部分分配" },
    { value: "FULLY_ALLOCATED", label: "全部分配" },
];

const MawbStockFilter = ({ onSearch, onReset, onRefresh }) => {
    const [form] = Form.useForm();

    const handleSearch = () => {
        const values = form.getFieldsValue();
        const params = {};
        if (values.airline_prefix) params.airline_prefix = values.airline_prefix;
        if (values.status) params.status = values.status;
        onSearch(params);
    };

    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") handleSearch();
    };

    return (
        <Form form={form} layout="inline" className="filter-form">
            <Row gutter={[16, 16]} style={{ width: "100%" }}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="airline_prefix" label="航司前缀">
                        <Input
                            placeholder="如 160"
                            maxLength={3}
                            allowClear
                            onKeyDown={handleKeyPress}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item name="status" label="状态">
                        <Select placeholder="全部" allowClear>
                            {statusOptions.map((opt) => (
                                <Option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>
                                搜索
                            </Button>
                            <Button icon={<ReloadOutlined />} onClick={handleReset}>
                                重置
                            </Button>
                            <Button icon={<SyncOutlined />} onClick={onRefresh}>
                                刷新
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default MawbStockFilter;
